import './Panel.css';

interface PanelProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

const Panel = ({ children, className = '', ...rest }: PanelProps) => {
  return (
    <div className={`panel ${className}`} {...rest}>
      {children}
    </div>
  );
};

export default Panel;
